import { Theme, css } from '@emotion/react';

import { Fragment } from 'react';

import { FontSizes, Spacing } from 'chatie-design-system';
import classnames from 'classnames';

const horizontalFilterCSS = (theme: Theme) => css`
  button {
    font-size: ${FontSizes.xsmall}px;
    color: ${theme.var.gray500};

    &.active {
      color: ${theme.var.black};
    }
  }

  span {
    display: inline-block;
    height: 12px;
    border-left: 1px solid ${theme.border.light};
    margin: 0 ${Spacing.xsmall}px;
    vertical-align: middle;
  }
`;

export type IFilter<T> = {
  label: string;
  value: T;
};

type Props<T = unknown> = {
  options: IFilter<T>[];
  selected?: T;
  onChange?: (filter: T) => void;
};

const HorizontalFilter = <T,>({ options, selected, onChange }: Props<T>) => {
  return (
    <div css={horizontalFilterCSS}>
      {options.map((option, i) => (
        <Fragment key={`horizontal-filter-${option.value}`}>
          {i > 0 && <span />}
          <button
            onClick={() => onChange?.(option.value)}
            className={classnames(
              option.value === selected ? 'active' : undefined,
              'text-btn'
            )}
          >
            {option.label}
          </button>
        </Fragment>
      ))}
    </div>
  );
};

export default HorizontalFilter;
